import { c as _c } from "react/compiler-runtime";
import { Table as ComponentsTable } from '@systemeio/components';
import { twMerge } from 'tailwind-merge';
import { resolveRowId } from '../utils';
import { getRowClassName, getRowClickHandler, getRowTestAttributes } from '../utils/table-row-helpers';
import { useSortableRow } from '../utils/use-sortable-row';
import type { CardRowProps, RowsProps, TableViewProps } from './view-props';
function CardRow(t0) {
  const $ = _c(18);
  const {
    row,
    visibleColumns,
    testAttributePostfix,
    isSortable,
    rowClassName,
    renderRow,
    getRowId,
    onRowClick
  } = t0;
  const rowId = resolveRowId({
    row,
    getRowId
  });
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    style
  } = useSortableRow({
    rowId,
    isSortable
  });
  const resolvedRowClassName = getRowClassName(row, rowClassName);
  let t1;
  if ($[0] !== onRowClick || $[1] !== row) {
    t1 = getRowClickHandler(row, onRowClick);
    $[0] = onRowClick;
    $[1] = row;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rowClickHandler = t1;
  const testAttributes = getRowTestAttributes(rowId, testAttributePostfix);
  const t2 = ComponentsTable;
  const t3 = twMerge(isDragging && "border-border-accent border-dashed", isSortable ? "cursor-grab" : onRowClick ? "cursor-pointer" : "cursor-auto", resolvedRowClassName);
  let t4;
  if ($[3] !== renderRow || $[4] !== row || $[5] !== visibleColumns) {
    t4 = renderRow ? renderRow(row) : visibleColumns.map((column, index) => {
      const renderMethod = column.onRenderSmall ? column.onRenderSmall : column.onRender;
      const content = renderMethod(row);
      return <ComponentsTable.Mobile.Cell key={`${column.key}-${index}`} className={column.className} label={column.header}>{content}</ComponentsTable.Mobile.Cell>;
    });
    $[3] = renderRow;
    $[4] = row;
    $[5] = visibleColumns;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== attributes || $[8] !== listeners || $[9] !== rowClickHandler || $[10] !== rowId || $[11] !== setNodeRef || $[12] !== style || $[13] !== t2.Mobile.Card || $[14] !== t3 || $[15] !== t4 || $[16] !== testAttributes) {
    t5 = <t2.Mobile.Card ref={setNodeRef} id={rowId} style={style} className={t3} onClick={rowClickHandler} {...attributes} {...listeners} {...testAttributes}>{t4}</t2.Mobile.Card>;
    $[7] = attributes;
    $[8] = listeners;
    $[9] = rowClickHandler;
    $[10] = rowId;
    $[11] = setNodeRef;
    $[12] = style;
    $[13] = t2.Mobile.Card;
    $[14] = t3;
    $[15] = t4;
    $[16] = testAttributes;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
function CardRows(t0) {
  const $ = _c(10);
  const {
    data,
    limiter,
    visibleColumns,
    testAttributePostfix,
    isSortable,
    rowClassName,
    getRowId,
    onRowClick,
    renderRow
  } = t0;
  let t1;
  if ($[0] !== data || $[1] !== getRowId || $[2] !== isSortable || $[3] !== limiter?.limit || $[4] !== onRowClick || $[5] !== renderRow || $[6] !== rowClassName || $[7] !== testAttributePostfix || $[8] !== visibleColumns) {
    t1 = data === undefined ? <ComponentsTable.Mobile.Body>{Array.from(Array(Math.min(limiter?.limit || 10, 50)).keys()).map(index => <ComponentsTable.Mobile.Card key={index}>{visibleColumns.map(_temp)}</ComponentsTable.Mobile.Card>)}</ComponentsTable.Mobile.Body> : <ComponentsTable.Mobile.Body>{data.items.map(row => <CardRow key={resolveRowId({
        row,
        getRowId
      })} row={row} visibleColumns={visibleColumns} testAttributePostfix={testAttributePostfix} isSortable={isSortable} rowClassName={rowClassName} renderRow={renderRow} getRowId={getRowId} onRowClick={onRowClick} />)}</ComponentsTable.Mobile.Body>;
    $[0] = data;
    $[1] = getRowId;
    $[2] = isSortable;
    $[3] = limiter?.limit;
    $[4] = onRowClick;
    $[5] = renderRow;
    $[6] = rowClassName;
    $[7] = testAttributePostfix;
    $[8] = visibleColumns;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}
function _temp(column, index_0) {
  return <ComponentsTable.Mobile.LoaderCell key={`${column.key}-${index_0}`} />;
}
export function MobileView(t0) {
  const $ = _c(13);
  let allowSelectAll;
  let rowsProps;
  let selectionProps;
  if ($[0] !== t0) {
    ({
      selectionProps,
      allowSelectAll,
      ...rowsProps
    } = t0);
    $[0] = t0;
    $[1] = allowSelectAll;
    $[2] = rowsProps;
    $[3] = selectionProps;
  } else {
    allowSelectAll = $[1];
    rowsProps = $[2];
    selectionProps = $[3];
  }
  let t1;
  if ($[4] !== allowSelectAll || $[5] !== selectionProps.selectionMode) {
    t1 = selectionProps.selectionMode && <ComponentsTable.Mobile.Header allowSelectAll={allowSelectAll} />;
    $[4] = allowSelectAll;
    $[5] = selectionProps.selectionMode;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== rowsProps) {
    t2 = <CardRows {...rowsProps} />;
    $[7] = rowsProps;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== selectionProps || $[10] !== t1 || $[11] !== t2) {
    t3 = <ComponentsTable.Mobile.Root {...selectionProps}>{t1}{t2}</ComponentsTable.Mobile.Root>;
    $[9] = selectionProps;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}